import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';

import { POLL_KEYS } from '@/api/usePolls';
import { POLL_DETAIL_KEYS } from '@/api/usePoll';

import type { CastVotePayload, Vote } from '@/types/poll';

export function useCastVote(pollSlug: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: CastVotePayload) => {
            const { data } = await api.post<Vote[]>(API_ROUTES.pollVote(pollSlug), payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: POLL_DETAIL_KEYS.detail(pollSlug) });
            queryClient.invalidateQueries({ queryKey: POLL_KEYS.all });
            toast.success('Voto registrado');
        },
        onError: () => {
            toast.error('No se pudo registrar tu voto. Intenta de nuevo.');
        },
    });
}

export function useRemoveVote(pollSlug: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            await api.delete(API_ROUTES.pollVote(pollSlug));
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: POLL_DETAIL_KEYS.detail(pollSlug) });
            queryClient.invalidateQueries({ queryKey: POLL_KEYS.all });
            toast.success('Voto eliminado');
        },
        onError: () => {
            toast.error('No se pudo quitar tu voto. Intenta de nuevo.');
        },
    });
}
